<template>
  <section class="AppointmentDetailPage">
    <header class="Header">
      <Button class="header-buttons" @click="$router.back()"><ArrowLeftIcon size="24" /></Button>
      <a class="Header-logo" href="/">
        <img src="/map/dist/skin/logo.svg" alt="Logo" />
      </a>
      <span v-if="isLoading" style="color: #777; font-size: 13px; position: absolute; display: flex; justify-content: center; align-items: center; left: 50%; top: 5px; margin-left: -15px; background: #fff; box-shadow: 0 2px 5px rgba(0,0,0,0.5); border-radius: 9999px; width: 30px; height: 30px;">
        <LoadingIndicator style="height: 16px;"/>
      </span>
    </header>
    <main v-if="company != null">
      <div  class="appointment">
        <div class="phone-section">
          <a class="icon" :class="{disabled: empty(company.phone) && empty(company.mobile)}"
             :href="empty(company.phone) ? (empty(company.mobile) ? '' : `tel:${company.mobile}`) :
             `tel:${company.phone}`">
          <Phone-icon/></a>
          <span>
            {{company.salutation}}
            {{ company.companyname}}<br/>
            {{ company.customfield_afspraakisolatie }}<br/>
            {{ company.customfield_afspraakwoningtype }}
          </span>
        </div>
        <div class="location-section">
          <a class="icon" :class="{disabled: company.locationUrl == null}"
             :href="company.locationUrl == null ? '' : company.locationUrl"
             target="_blank"><Navigation-icon/></a>
          <span>
            {{ company.visitingaddress_street }} {{ company.visitingaddress_streetnumber}}<br/>
            {{ company.visitingaddress_zipcode }}<br/>
            {{ company.visitingaddress_city }}
          </span>
        </div>
        <div class="time-section">
          <span>
            {{ company.customfield_afspraaktijdstip != null ? company.customfield_afspraaktijdstip.substring(0, 5) : '-' }}
          </span>
        </div>
      </div>
      <div class="specifications">
        <p class="specification-line">
          <span>Afspraak:</span>
          <span>{{ empty(company.customfield_afspraakdatum) ? 'onbekend' :
              reverseDate(company.customfield_afspraakdatum)}}</span>
        </p>
        <p class="specification-line">
          <span>Tijd:</span>
          <span>{{ empty(company.customfield_afspraaktijdstip) ? 'onbekend' :
              getTime(company.customfield_afspraaktijdstip, company.customfield_afspraakwoningtype ===
              'vrijstaande-woning' ? '1.25' : '1')
            }}</span>
        </p>
        <p class="specification-line">
          <span>Accountmanager:</span>
          <span>{{ empty(company.agent) ? 'onbekend' :
              company.agent.display_name}}</span>
        </p>
      </div>
      <div class="specifications">
        <p class="specification-line">
          <span>Email:</span>
          <span>{{ empty(company.email) ? 'onbekend' :
              company.email}}</span>
        </p>
        <p class="specification-line">
          <span>Telefoon:</span>
          <span v-if="empty(company.phone) && empty(company.mobile)">onbekend
          </span>
          <span v-if="!empty(company.phone) || !empty(company.mobile)">
            {{!empty(company.phone) ? company.phone : company.mobile}}
          </span>
        </p>
        <p class="specification-line" v-if="!empty(company.phone) && !empty(company.mobile)">
          <span></span>
          <span>
            {{company.mobile}}
          </span>
        </p>
        <p class="specification-line">
          <span>Klantnummer:</span>
          <span>{{ empty(company.customernumber) ? 'onbekend' :
              company.customernumber}}</span>
        </p>
        <p class="specification-line">
          <span>Leadkanaal:</span>
          <span>{{ empty(company.customfield_leadkanaal) ? 'onbekend' :
              company.customfield_leadkanaal}}</span>
        </p>
        <p class="specification-line" v-if="empty(company.customfield_dmbron) === false">
          <span>Bron:</span>
          <span>{{company.customfield_dmbron}}</span>
        </p>
        <p class="specification-line" v-if="empty(company.customfield_leadkanaal) === false &&
        company.customfield_leadkanaal === 'KMK'">
          <span>KMK:</span>
          <span>{{empty(company.customfield_kmkmedewerker) ? 'onbekend' : company
              .customfield_kmkmedewerker}}</span>
        </p>
        <p class="specification-line"
           v-if="empty(company.customfield_leadkanaal) === false &&
        company.customfield_leadkanaal === 'KMK'" @click="$router.push({ name: 'appointmentdetail', params:
         {id: company.kmkReferer.id} })">
          <span>Aangebracht door:</span>
          <span :class="empty(company.kmkReferer) ? '' : 'link'">{{empty(company.kmkReferer) ?
              'onbekend': company.kmkReferer.firstname }} {{empty(company.kmkReferer) ? '' : company.kmkReferer.infix}}
            {{empty(company.kmkReferer) ? '' : company.kmkReferer.lastname}}</span>
        </p>
      </div>
      <div class="specifications">
        <p class="specification-line">
          <span>Bouwjaar:</span>
          <span>{{ empty(company.customfield_afspraakbouwjaar) ? 'onbekend' :
              company.customfield_afspraakbouwjaar}}</span>
        </p>
        <p class="specification-line">
          <span>Buitenmuren:</span>
          <span>{{ empty(company.customfield_afspraakbuitenmuren) ? 'onbekend' :
              company.customfield_afspraakbuitenmuren}}</span>
        </p>
        <p class="specification-line">
          <span>Kruipruimte toegankelijk:</span>
          <span>{{ empty(company.customfield_afspraakkruipruimtetoegankelijk) ? 'onbekend' :
              company.customfield_afspraakkruipruimtetoegankelijk === '0' ? 'Nee' : 'Ja'}}</span>
        </p>
        <p class="specification-line">
          <span>Kruipruimte:</span>
          <span>{{ empty(company.customfield_afspraakhoogtekruipruimte) ? 'onbekend' :
              company.customfield_afspraakhoogtekruipruimte}}</span>
        </p>
        <p class="specification-line">
          <span>Kruipruimte droog:</span>
          <span>{{ empty(company.customfield_afspraakkruipruimtedroog) ? 'onbekend' :
              company.customfield_afspraakkruipruimtedroog === '0' ? 'Nee' : 'Ja'}}</span>
        </p>
        <p class="specification-line">
          <span>Vloerverwarming:</span>
          <span>{{ empty(company.customfield_afspraakvloerverwarming) ? 'onbekend' :
              company.customfield_afspraakvloerverwarming === '0' ? 'Nee' : 'Ja'}}</span>
        </p>
        <textarea :value="empty(company.notes) ? 'Geen notities' : company.notes" disabled readonly></textarea>
      </div>
      <form class="specifications form-fields-container" method="post" @submit.prevent="saveFields()">
        <div class="form-four-columns">
          <select class="SelectField" name="agent_id" v-model="formFields.customfield_klantaanwezig"
                  :class="formFields.customfield_klantaanwezig == null ? 'placeholder_mode' : ''">
            <option selected="selected" disabled :value="null">Klant Aanwezig?</option>
            <option value="Onbekend">Onbekend</option>
            <option value="Man thuis">Man thuis</option>
            <option value="Vrouw thuis">Vrouw thuis</option>
            <option value="Man/vrouw thuis">Man/vrouw thuis</option>
            <option value="Alleenstaand">Alleenstaand</option>
          </select>
          <span v-if="errors.includes('customfield_klantaanwezig')" class="form-error">Klant aanwezig mag
            niet leeg zijn</span>
        </div>
        <div class="form-four-columns">
          <select class="SelectField" name="agent_id" v-model="formFields.customfield_leeftijdklant"
                  :class="formFields.customfield_leeftijdklant == null ? 'placeholder_mode' : ''">
            <option selected="selected" disabled :value="null">Leeftijd van klant</option>
            <option value="Onbekend">Onbekend</option>
            <option value="25/29">25/29</option>
            <option value="30/34">30/34</option>
            <option value="35/39">35/39</option>
            <option value="40/44">40/44</option>
            <option value="45/49">45/49</option>
            <option value="50/54">50/54</option>
            <option value="55/59">55/59</option>
            <option value="60/64">60/64</option>
            <option value="65/69">65/69</option>
            <option value="70/74">70/74</option>
            <option value="75+">75+</option>
          </select>
          <span v-if="errors.includes('customfield_leeftijdklant')" class="form-error">Leeftijd klant mag
            niet leeg zijn</span>
        </div>
        <div class="form-four-columns">
          <select class="SelectField" name="agent_id" v-model="formFields.customfield_directverkocht"
                  :class="formFields.customfield_directverkocht == null ? 'placeholder_mode' : ''">
            <option selected="selected" disabled :value="null">Direct Verkocht</option>
            <option value="Onbekend">Onbekend</option>
            <option value="Ja">Ja</option>
            <option value="Nee">Nee</option>
          </select>
          <span v-if="errors.includes('customfield_directverkocht')" class="form-error">Direct verkocht mag
            niet leeg zijn</span>
        </div>
        <div class="form-four-columns" v-if="formFields.customfield_directverkocht === 'Nee' ||
        	(formFields.customfield_verkochteproducten.length === 1 && formFields.customfield_verkochteproducten.includes('Impregneren'))">
          <select class="SelectField" name="agent_id" v-model="formFields.customfield_redennietverkocht"
                  :class="formFields.customfield_redennietverkocht == null ? 'placeholder_mode' : ''">
            <option selected="selected" disabled :value="null">Reden niet verkocht</option>
            <option value="Onbekend">Onbekend</option>
            <option value="Te duur">Te duur</option>
            <option value="Concurrent">Concurrent</option>
            <option value="Technisch Niet Mogelijk">Technisch Niet Mogelijk</option>
            <option value="Twijfelaar">Twijfelaar</option>
            <option value="Vergelijken">Vergelijken</option>
            <option value="Nadenken">Nadenken</option>
            <option value="Geen geld">Geen geld</option>
            <option value="Concurrent komt nog">Concurrent komt nog</option>
            <option value="Overleggen">Overleggen</option>
            <option value="Doorschuiven lange termijn">Doorschuiven lange termijn</option>
            <option value="Man niet thuis">Man niet thuis</option>
            <option value="Vrouw niet thuis">Vrouw niet thuis</option>
            <option value="Akkoord ander bedrijf">Akkoord ander bedrijf</option>
          </select>
          <span v-if="errors.includes('customfield_redennietverkocht')" class="form-error">Reden niet
            verkocht mag niet leeg zijn</span>
        </div>
        <div class="form-four-columns" v-if="formFields.customfield_directverkocht === 'Nee' &&
        formFields.customfield_redennietverkocht === 'Technisch Niet Mogelijk'">
          <select class="SelectField" name="agent_id" v-model="formFields.customfield_technischnietmogelijk"
                  :class="formFields.customfield_technischnietmogelijk == null ? 'placeholder_mode' : ''">
            <option selected="selected" disabled :value="null">Technisch Niet Mogelijk</option>
            <option value="Alkreflex">Alkreflex</option>
            <option value="Geschilderd">Geschilderd</option>
            <option value="Glaswolvlokken">Glaswolvlokken</option>
            <option value="Houtskelet">Houtskelet</option>
            <option value="Kalkzandsteen">Kalkzandsteen</option>
            <option value="MBI steen">MBI steen</option>
            <option value="Niet bereikbaar met bus">Niet bereikbaar met bus</option>
            <option value="Parels in de spouw">Parels in de spouw</option>
            <option value="Rolluiken spouw">Rolluiken spouw</option>
            <option value="Spouwvervuiling">Spouwvervuiling</option>
            <option value="Strengperssteen">Strengperssteen</option>
            <option value="Te kleine restruimte">Te kleine restruimte</option>
            <option value="Te kleine voeg">Te kleine voeg</option>
            <option value="Te lage kruipruimte">Te lage kruipruimte</option>
            <option value="Verblendsteen">Verblendsteen</option>
            <option value="Huurwoning">Huurwoning</option>
          </select>
          <span v-if="errors.includes('customfield_technischnietmogelijk')" class="form-error">Technisch
            niet mogelijk mag niet leeg zijn</span>
        </div>
        <fieldset class="form-four-columns checkbox-container" v-if="formFields.customfield_directverkocht
        === 'Ja'">
          <legend>Verkochte producten</legend>
          <input class="checkbox" type="checkbox" id="spouw" value="Spouw"
                 v-model="formFields.customfield_verkochteproducten"><label
            for="spouw">Spouw</label>
          <input class="checkbox" type="checkbox" id="leeghalen-vullen" value="Leeghalen en vullen"
                 v-model="formFields.customfield_verkochteproducten"><label
            for="leeghalen-vullen">Leeghalen en vullen</label>
          <input class="checkbox" type="checkbox" id="vloer" value="Vloer" v-model="formFields.customfield_verkochteproducten"><label
            for="vloer">Vloer</label>
          <input class="checkbox" type="checkbox" id="bodem" value="Bodem" v-model="formFields.customfield_verkochteproducten"><label
            for="bodem">Bodem</label>
          <input class="checkbox" type="checkbox" id="impregneren" value="Impregneren" v-model="formFields.customfield_verkochteproducten"><label
            for="impregneren">Impregneren</label>
        </fieldset>
        <div class="form-four-columns currency-input"
             v-if="formFields.customfield_directverkocht === 'Ja' &&
             formFields.customfield_verkochteproducten.length > 0">
          <span @click="$refs.currencyInput.focus()">€</span>
          <input type="number" min="0.00" step="0.01"  v-model="formFields.customfield_verkoopbedrag"
                 @focusout="formFields.customfield_verkoopbedrag = formatPrice(formFields.customfield_verkoopbedrag)"
                 placeholder="Verkoopbedrag" ref="currencyInput"
                 name="customfield_verkoopbedrag">
          <span v-if="errors.includes('customfield_verkoopbedrag')" class="form-error">Verkoopbedrag mag niet
            leeg zijn</span>
        </div>
        <div class="form-four-columns" v-if="formFields.customfield_directverkocht === 'Ja'">
          <DateField v-model="formFields.customfield_datumaantafel"
                     placeholder="Afgesproken datum voor uitvoering" />
          <span v-if="errors.includes('customfield_datumaantafel')" class="form-error">Afgesproken datum mag
            niet leeg zijn</span>
        </div>
        <div class="form-four-columns" v-if="formFields.customfield_directverkocht === 'Ja' &&
        !empty(formFields.customfield_verkoopbedrag)">
          <select class="SelectField" name="agent_id" v-model="formFields.customfield_subsidie"
                  :class="formFields.customfield_subsidie == null ? 'placeholder_mode' : ''">
            <option selected="selected" disabled :value="null">Subsidie</option>
            <option value="Onbekend">Onbekend</option>
            <option value="Ja">Ja</option>
            <option value="Nee">Nee</option>
          </select>
          <span v-if="errors.includes('customfield_subsidie')" class="form-error">Subsidie mag niet leeg
            zijn</span>
        </div>
        <div class="form-four-columns">
          <select class="SelectField" name="agent_id" v-model="formFields.customfield_vloergeinspecteerd"
                  :class="formFields.customfield_vloergeinspecteerd == null ? 'placeholder_mode' : ''">
            <option selected="selected" disabled :value="null">Vloer Geïnspecteerd?</option>
            <option value="Onbekend">Onbekend</option>
            <option value="Geen interesse in vloerisolatie">Geen interesse in vloerisolatie</option>
            <option value="Kruipruimte niet bereikbaar">Kruipruimte niet bereikbaar</option>
            <option value="Geen kruipruimte aanwezig">Geen kruipruimte aanwezig</option>
            <option value="Al na geïsoleerd">Al na geïsoleerd</option>
            <option value="Niet geïsoleerd 50+ cm">Niet geïsoleerd 50+ cm</option>
            <option value="Niet geïsoleerd 50- cm">Niet geïsoleerd 50- cm</option>
            <option value="Vloerisolatie verkocht">Vloerisolatie verkocht</option>
            <option value="Bodemisolatie verkocht">Bodemisolatie verkocht</option>
            <option value="Vloerisolatie offerte aangeboden">Vloerisolatie offerte aangeboden</option>
            <option value="Bodemisolatie offerte aangeboden">Bodemisolatie offerte aangeboden</option>
          </select>
          <span v-if="errors.includes('customfield_vloergeinspecteerd')" class="form-error">Vloer Geïnspecteerd mag niet
            leeg zijn</span>
        </div>
        <div class="form-four-columns toggle-container" @click="formFields.isKmk = !formFields.isKmk">
          <label for="isKmk">KMK</label>
          <ToggleField :checked="formFields.isKmk" type="checkbox" name="isKmk" ref="kmkCheckbox" />
        </div>
        <div class="form-four-columns">
          <textarea v-model="formFields.customfield_opmerkingafspraak" placeholder="Notitie"></textarea>
          <span v-if="errors.includes('customfield_opmerkingafspraak')" class="form-error">Opmerking mag niet
            leeg zijn</span>
        </div>
        <file-upload v-if="allowedFilesOfferte" :start-upload="startUpload" title="Offerte"
					 :key="'1' + $route.path"
                     type="sales/offerte"
                     :company-id="company.id"
                     class="form-four-columns"
                     accept="image/*"></file-upload>
        <file-upload v-if="allowedFilesOfferte" :start-upload="startUpload" title="Voorkant uitwerking" type="sales/voorkant"
					 :key="'2' + $route.path"
                     :company-id="company.id"
                     class="form-four-columns"
                     accept="image/*"></file-upload>
        <file-upload v-if="allowedFilesOfferte" :start-upload="startUpload" title="Achterkant uitwerking" type="sales/achterkant"
					 :key="'3' + $route.path"
                     :company-id="company.id"
                      class="form-four-columns" accept="image/*"></file-upload>
        <file-upload v-if="allowedFilesOfferte" :start-upload="startUpload" title="Subsidie" type="sales/subsidie"
					 :key="'4' + $route.path"
                      :company-id="company.id"
                      class="form-four-columns" accept="image/*"></file-upload>
        <file-upload v-if="allowedFilesOfferte" :start-upload="startUpload" title="Foto's" type="sales/fotos"
					 :key="'5' + $route.path"
                      :company-id="company.id"
                      class="form-four-columns" accept="image/*"></file-upload>
        <Button class="save-button form-four-columns" type="submit">
          <template v-slot:icon>
            <SaveIcon size="1.25x" />
          </template> Terugkoppeling inleveren</Button>

      </form>
    </main>
  </section>
</template>

<script>

import DateField from "@/components/DateField";
import ToggleField from "@/components/ToggleField";
import { mapState, mapActions, mapGetters } from 'vuex';
import Button from '@/components/Button';
import FileUpload from '@/components/AppointmentFileUpload';
import LoadingIndicator from '@/components/LoadingIndicator';
import moment from 'moment';
import {
  PhoneIcon, NavigationIcon, RefreshCwIcon, LogOutIcon,
  ArrowLeftIcon, ArrowRightIcon, CalendarIcon, SearchIcon, SaveIcon
} from 'vue-feather-icons';
import {
  formatPrice
} from "@/common/forms-util";
import 'moment/locale/nl';
import { calculatePlanningAppointmentEndTime } from "../utils";

export default {
  components: {
    Button,
    LoadingIndicator,
    PhoneIcon,
    NavigationIcon,
    RefreshCwIcon,
    LogOutIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    CalendarIcon,
    SearchIcon,
    SaveIcon,
    DateField,
    FileUpload,
    ToggleField
  },

  data() {
    return {
      id: this.$route.params.id,
      appointment: null,
      startUpload: false,
      allowedFilesOfferte: false,
      allowedFilesVoorkant: false,
      allowedFilesAchterkant: false,
      allowedFilesSubsidie: false,
      allowedFilesFotos: false,
      errors: [],
      allowedNotEmptyFields: [
        "customfield_klantaanwezig",
        "customfield_leeftijdklant",
        "customfield_directverkocht",
        "customfield_vloergeinspecteerd"
      ],
      conditionalAllowedNotEmptyFields: {
        customfield_redennietverkocht: {
          field: 'customfield_directverkocht',
          equals: 'Nee'
        },
        customfield_technischnietmogelijk: {
          field: 'customfield_redennietverkocht',
          equals: 'Technisch Niet Mogelijk'
        },
      },
      formFields: {
        customfield_klantaanwezig: null,
        customfield_leeftijdklant: null,
        customfield_directverkocht: null,
        customfield_verkochteproducten: [],
        customfield_verkoopbedrag: null,
        customfield_datumaantafel: null,
        customfield_subsidie: null,
        customfield_vloergeinspecteerd: null,
        customfield_opmerkingafspraak: null,
        customfield_technischnietmogelijk: null,
        customfield_redennietverkocht: null,
        isKmk: false,
      }
    };
  },

  created() {
    this.getCompany(this.$route.params.id);
    this.allowedFilesOfferte = this.allowedTo("files/view/sales/offerte");
    this.allowedFilesVoorkant = this.allowedTo("files/view/sales/voorkant");
    this.allowedFilesAchterkant = this.allowedTo("files/view/sales/achterkant");
    this.allowedFilesSubsidie = this.allowedTo("files/view/sales/subsidie");
    this.allowedFilesFotos = this.allowedTo("files/view/sales/fotos");
  },

  watch: {
    '$route.params.id': function (id) {
      this.getCompany(id);
    }
  },

  destroyed() {
    clearTimeout(this.periodical);
  },

  computed: {
    ...mapState({
      isLoading: 'loading',
    }),
    ...mapState('auth', {
      viewer: 'viewer',
    }),
    ...mapState('mobile', {
      appointments: 'appointments',
      company: 'company'
    }),
    ...mapGetters({
      allowedTo: 'auth/allowedTo',
    }),
  },

  methods: {
    ...mapActions({
      logoutUser: 'auth/logoutUser',
      updateCompany: 'mobile/updateCompany',
      fetchCompany: 'mobile/getCompany',
    }),

    formatPrice: formatPrice,

    validateFields() {
      this.errors = [];
      this.allowedNotEmptyFields.forEach(field => {
        if (this.formFields[field] == null) {
          this.errors.push(field);
        }
      });
      for (const [field, condition] of Object.entries(this.conditionalAllowedNotEmptyFields)) {
        if (this.formFields[condition.field] === condition.equals && this.formFields[field] ===
            null) {
          this.errors.push(field);
        }
      }
    },

     getCompany(id) {
        this.fetchCompany({id: parseInt(id, 10)}).then(company => {
          if(this.company == null) {
            this.$router.back();
          } else {
            this.setFormValues(this.company);
          }
        }, error => {
          this.$router.back();
        });
      },

    setFormValues(company) {
      this.formFields = {
        customfield_klantaanwezig: null,
        customfield_leeftijdklant: null,
        customfield_directverkocht: null,
        customfield_verkochteproducten: [],
        customfield_verkoopbedrag: null,
        customfield_datumaantafel: null,
        customfield_subsidie: null,
        customfield_vloergeinspecteerd: null,
        customfield_opmerkingafspraak: null,
        customfield_technischnietmogelijk: null,
        customfield_redennietverkocht: null,
        isFeedback: true,
        isKmk: false
      };

      Object.keys(this.formFields).forEach(formField => {
        if(company[formField] != null && company[formField] !== "") {
          if(formField === "customfield_verkochteproducten") {
            this.formFields[formField] = company[formField].split(",").filter(v => v !== "");
          } else {
            this.formFields[formField] = company[formField];
          }
        }
      });
    },

    empty(value) {
      return value == null || (typeof value === "string" && value.trim() === "");
    },

    clearConditionFields() {
      // only when directverkocht is Ja verkochteproducten may contain values
      // When directverkocht is Nee redennietverkocht may be filled
      if(this.formFields.customfield_directverkocht === "Nee") {
        this.formFields.customfield_verkochteproducten = [];
      } else {
        this.formFields.customfield_redennietverkocht = null;
      }

      // only when verkochteproducten is bigger than 1 verkoopbedrag may be filled
      if(this.formFields.customfield_verkochteproducten.length === 0) {
        this.formFields.customfield_verkoopbedrag = null;
      }

      // only when verkoopbedrag is filled subsidie may be filled
      if(this.formFields.customfield_verkoopbedrag == null) {
        this.formFields.customfield_subsidie = null;
      }

      // only when redennietverkocht is technisch niet mogelijk, technicschnietmogelijk may be filled
      if(this.formFields.customfield_redennietverkocht !== "Technisch Niet Mogelijk") {
        this.formFields.customfield_technischnietmogelijk = null;
      }
    },
    reverseDate(date) {
      return date.split("-").reverse().join("-");
    },

    getTime(time, durationHours) {
      return calculatePlanningAppointmentEndTime(time, durationHours);
    },

    saveFields() {
      this.clearConditionFields();
      this.validateFields();
      if (this.errors.length > 0) {
        return;
      }
      const data = Object.assign({id: this.company.id}, this.formFields,
          {customfield_verkochteproducten: this.formFields.customfield_verkochteproducten.toString()});
      this.updateCompany(data).then(result => {
        this.startUpload = true;
        setTimeout(() => {
          this.startUpload = false;
        });
        this.setFormValues(result);

        this.$notify({
          group: 'app',
          title: 'Opslaan gelukt',
          type: 'success',
          text: `De terugkoppeling is succesvol opgeslagen`,
        });
      }).catch(error => {
        this.$notify({
          group: 'app',
          title: 'Fout bij opslaan',
          type: 'error',
          text: `De terugkoppeling kon niet opgeslagen worden`,
        });
      });
    },
  },
};
</script>

<style scoped>

main {
  overflow: auto;
  height: calc(100% - 46px);
}

.AppointmentDetailPage {
  height: 100%;
}

.Header {
  box-shadow: none;
  border-bottom: 2px solid #eee;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
}

.header-buttons {
  box-shadow: none;
  padding: 8px;
  max-width: 64px;
}

.Header-logo {
  margin-left: 0;
  display: flex;
  height: 100%;
  width: 200px;
  align-items: center;
  justify-content: center;
}


h2, h3 {
  margin: 0 0 0.5em 0;
}

.appointment {
  display: grid;
  background-color: #fff;
  border-bottom: 2px solid #eee;
  grid-template-areas:
        "phone time"
        "location time";
  padding: 4px 0;
  color: #000;
}

.phone-section {
  grid-area: phone;
  display: flex;
  margin: 4px 8px;
  align-items: center;
}

.location-section {
  grid-area: location;
  display: flex;
  align-items: center;
  margin: 4px 8px;
}

.time-section {
  grid-area: time;
  display: flex;
  align-self: center;
  justify-content: flex-end;
  margin-right: 16px;
}

.time-section span {
  font-size: 2rem;
  font-weight: 900;
}

.icon {
  min-width: 60px;
  width: 60px;
  min-height: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #fff;
  border-radius: 8px;
  margin-right: 16px;
}

.icon.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  text-decoration: none;
  pointer-events: none;
}

.phone-section .icon {
  background: #1f88e5;
}

.location-section .icon {
  background: #35a5a4;
}

.icon path {
  fill: #FFF;
}

.icon polygon {
  fill: #FFF;
}

.specifications {
  border-bottom: 2px solid #eee;
}

.specification-line {
  display: flex;
  justify-content: space-between;
  margin:  16px 8px;
  font-size: 18px;
  font-weight: 500;
}

textarea {
  margin:  0 8px;
  width: calc(100% - 16px);
  font-size: 18px;
  min-height: 80px;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 8px;
}

.form-four-columns textarea {
  margin: 0;
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 5px;
}

span.link {
  text-decoration: underline;
}

.form-fields-container {
  padding: 16px 8px;
  border: 0;
}

.checkbox-container {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  border: 1px solid #aaa;
  border-radius: 5px;
  margin: 0;
}

.checkbox-container label {
  font-size: 18px;
  padding: 16px;
  font-weight: 500;
  color: #666;
}

.checkbox {
  height: 24px;
  width: 24px;
  accent-color: #35a5a4;
}

.currency-input {
  position: relative;
}

.currency-input span{
  font: inherit;
  position: absolute;
  height: 100%;
  line-height: 56px;
  left: 8px;
  font-size: 18px;
  font-weight: 500;
  color: #666;
}
.currency-input input{
  font: inherit;
  text-align:left;
  font-size: 18px;
  padding: 16px 20px;
  height: unset;
  border: 1px solid #aaa;
  border-radius: 5px;
  font-weight: 500;
  color: #666;
}

.save-button {
  font: inherit;
  font-weight: 500;
  text-align: center;
  background-color: #35a5a4;
  color: white;
  border: none;
  height: 36px;
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 0 -8px -16px;
  border-radius: 4px 4px 0 0;
}

.form-fields-container .SelectField {
  font: inherit;
  font-size: 18px;
  padding: 16px 8px;
  height: unset;
  border: 1px solid #aaa;
  border-radius: 5px;
  font-weight: 500;
  color: #666;
}
textarea {
  font-size: 18px;
  padding: 16px 8px;
  border: 1px solid #aaa;
  border-radius: 5px;
  font-weight: 500;
  color: #666;
}

legend {
  font: inherit;
  font-weight: 500;
}

.toggle-container {
  display: flex;
  justify-content: space-between;
  padding: 8px 8px;
  font-size: 18px;
}

</style>
